<template>
  <app-action-btn
    :access="canModifyTableRows(role)"
    :show-tooltip="!canModifyTableRows(role)"
    top
    @click="canModifyTableRows(role).allowed && duplicateRowCB({
      tableId: scheduleId,
      tableType,
      rowId,
      projectId: $route.params.id,
    })">
    <template #iconWrapper>
      <v-icon
        small
        color="lightBlack">
        mdi-content-copy
      </v-icon>
    </template>
    Duplicate
  </app-action-btn>
</template>
<script>
import {
  mapActions, mapState, mapGetters,
} from 'vuex';
export default {
  name: 'TableCopyRow',
  props: {
    rowId: {
      type: String,
      default: null,
    },
    tableType: {
      type: String,
      default: 'schedule',
    },
  },
  computed: {
    ...mapState('ProjectDetailsTableSchedule', ['scheduleId']),
    ...mapState('ScheduleRows', ['checkboxSelectedRows']),
    ...mapState(['role']),
    ...mapGetters('UserRoles', ['canModifyTableRows']),
    ...mapGetters('ScheduleRows', ['isMultipleRowsSelected', 'sortedViewInfo']),
  },
  methods: {
    ...mapActions('ScheduleRows', ['duplicateRow', 'clearSelectedRows']),
    async duplicateRowCB(params) {
      if (this.isMultipleRowsSelected) {
        await this.duplicateSelectedRows(params);
        this.clearSelectedRows();
      }
      else {
        await this.duplicateSingleRow(params);
      }
    },
    async duplicateSingleRow(params) {
      params.rowNumber = this.getCurrRowNumber();
      this.duplicateRow(params);
    },
    async duplicateSelectedRows(params) {
      const rn = this.getCurrRowNumber();

      return Promise.all(this.checkboxSelectedRows.map(async(seletedRowId, index) => {
        await this.duplicateRow(
          {
            ...params,
            rowId: seletedRowId,
            rowNumber: index + rn,
          }
        );
      }));
    },
    getCurrRowNumber() {
      if (this.sortedViewInfo && this.sortedViewInfo.length > 0) {
        return this.sortedViewInfo.findIndex(row => row.id === this.rowId);
      }
      return 0;
    },
  },
};
</script>
